export default __webpack_public_path__ + "static/media/cert-market-HKIRC.da6ec92a.jpg";